import React from "react";
import Meta from "../../components/utils/Meta/Meta.util";
import { HeadProps } from "../../interfaces/Head.interface";
import StoryblokEntryTemplateContext from "../../interfaces/Storyblok/StoryblokEntryTemplateContext.interface";
import getPageContext from "../../utils/getPageContext.util";
import PageTemplate from "../Page.template";
import getURL from "../../utils/getURL.util";
import DynamicTemplate from "../../components/templates/DynamicTemplate/DynamicTemplate.component";

interface StoryblokEntryTemplateProps {
  pageContext: StoryblokEntryTemplateContext;
}

const StoryblokEntryTemplate: React.FC<StoryblokEntryTemplateProps> = ({
  pageContext,
}) => {
  return <DynamicTemplate context={getPageContext(pageContext)} />;
};

export default StoryblokEntryTemplate;

export const Head: React.FC<HeadProps> = ({ pageContext, location }) => {
  const {
    content: { SEO },
  } = getPageContext(pageContext);

  return SEO ? <Meta seo={SEO} url={getURL()}></Meta> : null;
};
